/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as strings from '@touchplan/strings';
import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { PopupOutput, PopupOutputType } from 'src/app/common/popup';
import { DependencyDisplay } from 'src/app/app-data/models/Dependencies';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { cssVar } from '@touchplan/css-var';

@Component({
	selector: 'dependency-deletion',
	templateUrl: './dependency-deletion.component.html',
	styleUrls: ['./dependency-deletion.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DependencyDeletionComponent {
	public appStrings = strings;
	public dependencyList: DependencyDisplay[] = [];
	protected _output$ = new Subject<PopupOutput>();
	public output$ = this._output$.asObservable();

	public static showDialog(
		dependencyOutput: DependencyDisplay[],
		onlyCancel: boolean,
		dialog: MatDialog
	): Observable<boolean> {
		const dialogRef = dialog.open(DependencyDeletionComponent, {
			maxWidth: cssVar.dialogWidthLg,
			data: { dependencyList: dependencyOutput, onlyCancel },
		} as MatDialogConfig);
		return dialogRef.componentInstance.output$.pipe(
			map((popupOutput) => popupOutput.type === PopupOutputType.update)
		);
	}

	constructor(
		public dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data: { dependencyList: DependencyDisplay[]; onlyCancel: boolean }
	) {}

	public writeOutput(data?) {
		this._output$.next({
			type: PopupOutputType.update,
			data,
		});
		this.complete();
	}

	public writeCancel(data?) {
		this._output$.next({
			type: PopupOutputType.canceled,
			data,
		});
		this.complete();
	}

	private complete() {
		this.dialog.closeAll();
		this._output$.complete();
	}
}
